var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKpmgEditConfirm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90.161,
    height: 71.811,
    viewBox: "0 0 90.161 71.811"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "ICN_Modal confirmare Modificare_Enabled"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 948",
    d: "M41.58 2.001a4 4 0 016.929 0l41.11 63.81a4 4 0 01-3.465 6H4.006a4 4 0 01-3.465-6z",
    fill: "#aa2aba"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1417"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 611"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 936",
    d: "M44.583 34.304a63.212 63.212 0 00-6.593 0 5.6 5.6 0 00-4.969 5.572c-.008 5.426-.052 8.984 0 14.335.132 5.061 4.343 5.226 4.893 5.289 4.113 0 6.384-.024 10.6 0a4.981 4.981 0 005.352-4.547c.011-3.034 0-7.039 0-7.039",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Union 43",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.391 39.313l-8.904 10.608-4.489 1.943c-1.354.549-1.817-.539-1.495-1.382.222-1.291 1.268-4.52 1.268-4.52l8.904-10.608a3.077 3.077 0 114.714 3.957z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.982 36.202a1.479 1.479 0 00-2.081.182L43.199 46.75c-.256.805-.698 2.249-.954 3.263l3.257-1.412 8.662-10.318a1.479 1.479 0 00-.182-2.081m1.029-1.226a3.077 3.077 0 01.378 4.336l-8.904 10.607-4.487 1.945c-.582.236-1 .17-1.26-.05-.347-.29-.418-.851-.235-1.332.224-1.292 1.268-4.52 1.268-4.52l8.904-10.607a3.078 3.078 0 014.336-.379z",
    fill: "#fff"
  })))));
}

export default SvgKpmgEditConfirm;